import React from "react";
import styled from "styled-components";

import Button from "../components/Button";
import Card from "../components/Cards";
// import ScrollContainer from "react-indiana-drag-scroll";

const CardsContainer = (props) => {
  console.log(props.cardsselection);
  if (!props.cardsselection?.length || !props.cardsselection) return <></>;
  return (
    <section {...props}>
      <HeaderSection title={props.title}>
        {props.tomore && (
          <Button variant="secondary" rounded="true" size="small" to={props.tomore}>
            see more
          </Button>
        )}
      </HeaderSection>
      <CardsContainerStyle tournament={props.tournament} games={props.games} full={props.full}>
        {props.cardsselection.map((card, index) => {
          return (
            <Card
              to={card.to} // stream
              game={card?.game}
              avatar={card?.avatar}
              state={card?.state}
              thumbnailImg={card?.thumbnail}
              gif={card?.gif}
              timeStatus={card?.timeStatus}
              title={card?.title}
              userURL={card?.userURL} // profile
              avatarImg={card?.avatar}
              verified={card?.verified}
              username={card?.username}
              tournamentKind={card?.tournamentKind}
              viewsCount={card?.viewerCount}
              timePassed={card?.timePassed}
              tags={card?.tags}
              key={index}
            />
          );
        })}
      </CardsContainerStyle>
    </section>
  );
};
export default CardsContainer;

export const HeaderSection = ({ title, backto, children }) => {
  if (title || children)
    return (
      <>
        {backto && (
          <Back nofocus="true" to={backto}>
            {"< Back"}
          </Back>
        )}
        <HeaderStyle>
          {title && <h2>{title}</h2>}
          {children}
        </HeaderStyle>
      </>
    );
  return null;
};

const Back = styled(Button)`
  padding-left: 0;
  margin-bottom: 10px;
  font-family: "Poppins Regular";
  color: ${({ theme }) => theme.color.lighterText} !important;
  &:hover {
    color: ${({ theme }) => theme.color.primary} !important;
  }
`;
const HeaderStyle = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
`;
const CardsContainerStyle = styled.div`
  display: flex;
  max-width: 100%;

  ${({ full }) =>
    full &&
    `
    flex-wrap: wrap;
    & > article{
      padding: 6px;
      margin: 0px !important;
      @media (min-width: 1400px) {
        min-width: 16.66%;
        max-width: 16.66%;
      }
      @media (max-width: 1400px) {
        min-width: 25%;
        max-width: 25%;
      }
      @media (max-width: 992px) {
        min-width: 25%;
        max-width: 25%;
      }
      @media (max-width: 992px) {
        min-width: 33.33%;
        max-width: 33.33%;
      }
      @media (max-width: 768px) {
        min-width: 50%;
        max-width: 50%;
      }
      @media (max-width: 576px) {
        min-width: 100%;
        max-width: 100%;
      }
    }
  `}
  ${({ games }) => games && "justify-content: flex-start;"}
  & > *:not(:last-child) {
    margin-right: 12px;
  }
`;
